import { Brand } from "@/components/news/Brand";

export const AuthShell = ({ title, kicker, children, wide = false }) => {
  return (
    <div className="min-h-screen bg-[#FAFAFA] flex flex-col">
      <div className="border-b-2 border-[#0B2A5B] bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Brand variant="auth" testId="auth-home-link" />
        </div>
      </div>
      <div className={`flex-1 w-full mx-auto px-4 sm:px-6 py-12 sm:py-16 ${wide ? "max-w-3xl" : "max-w-md"} fade-in`}>
        <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#1D4ED8]">{kicker}</p>
        <h1 className="mt-2 font-serif-head font-black text-4xl tracking-tight mb-8">{title}</h1>
        {children}
      </div>
    </div>
  );
};

export const Field = ({ label, children, hint }) => (
  <label className="block">
    <span className="text-xs font-bold uppercase tracking-[0.1em] text-zinc-600">{label}</span>
    <div className="mt-1.5">{children}</div>
    {hint && <span className="text-xs text-zinc-500 mt-1 block">{hint}</span>}
  </label>
);
